import React from 'react';

import { ThemeProvider } from '@platform/core/theme/theme-provider';

// TODO: remove this line once all locales are correctly placed.
// TODO: implement LocaleProvider, but first we need all tests to use customRender wrapper with CoreProviders.
import './i18n';

type CoreProvidersProps = React.PropsWithChildren<{
  themeMode?: React.ComponentProps<typeof ThemeProvider>['initialMode'];
}>;

export const CoreProviders = ({ children, themeMode }: CoreProvidersProps) => (
  <ThemeProvider initialMode={themeMode}>{children}</ThemeProvider>
);
